<template>
  <div class="archive">
    <FeaturedBrands :payload="payload" @update="filterProducts"/>
    <Filters :payload="payload" @update="filterProducts"/>
    <div class="product-listing">
      <Sorting :payload="payload" @update="sortProducts"/>
      <Listing/>
      <Pagination :payload="payload" @update="changePage"/>
    </div>
  </div>
</template>

<script>
import Filters from './components/Filters'
import Listing from './components/Listing'
import Sorting from './components/Sorting'
import Pagination from './components/Pagination'
import FeaturedBrands from './components/FeaturedBrands'

import { debounce } from 'lodash'
import { mapActions } from 'vuex'

export default {
  name: 'AppArchiveProduct',
  data () {
    return {
      defaultBrand: null,
      payload: {
        search: '',
        brands: [],
        colors: [],
        storage: [],
        store: '',
        price: {
          min: 0,
          max: 2500
        },
        sort: '',
        perPage: 20,
        page: 1
      }
    }
  },
  mounted() {
    this.checkDefaultBrand().then(() => {
      this.checkScreenSize().then(() => {
        this.loadProducts()
      })
    })

    document.addEventListener('storeSelected', (e) => {
      this.checkDefaultBrand().then(() => {
        this.checkScreenSize().then(() => {
          this.loadProducts()
        })
      })
    })
  },
  methods: {
    ...mapActions('products', ['getProducts']),
    filterProducts: debounce(function (payload) {
      this.payload.search = payload.search
      this.payload.brands = payload.brands
      this.payload.colors = payload.colors
      this.payload.storage = payload.storage
      this.payload.price.min = payload.price.min
      this.payload.price.max = payload.price.max
      this.payload.page = 1
      this.loadProducts()
    }, 700),
    sortProducts () {
      this.loadProducts()
    },
    changePage (page) {
      this.payload.page = page
      this.loadProducts()
    },
    orderProducts (payload) {
      this.payload.perPage = payload.perPage
      this.payload.sort = payload.sort
      this.payload.page = 1
      this.loadProducts()
    },
    loadProducts () {
      this.getProducts(this.payload).then(() => {
        if(!this.defaultBrand){
          const url = new URL(location.href)
          url.searchParams.set('search', this.payload.search)
          url.searchParams.set('brands', this.payload.brands)
          url.searchParams.set('colors', this.payload.colors)
          url.searchParams.set('storage', this.payload.storage)
          url.searchParams.set('price-min', this.payload.price.min)
          url.searchParams.set('price-max', this.payload.price.max)
          const newRelativePathQuery = window.location.pathname + '?' + url.searchParams.toString();
          history.pushState(null, '', newRelativePathQuery);
        }
      })
    },
    checkScreenSize () {
      return new Promise((resolve) => {
        if(window.innerWidth > 1400) this.payload.perPage = 20
        else if(window.innerWidth <= 1400 && window.innerWidth > 1200)  this.payload.perPage = 15
        else if(window.innerWidth <= 1200)  this.payload.perPage = 20
        resolve()
      })
    },
    checkDefaultBrand () {
      return new Promise((resolve) => {
        const el = document.getElementById('welcom-products')
        const brand = el.getAttribute('data-brand')
        if(brand){
          this.defaultBrand = brand
          this.payload.brands.push(brand)
        }
        resolve()
      })
    }
  },
  components: {
    Filters,
    Listing,
    Sorting,
    Pagination,
    FeaturedBrands
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/tools/*';
@import '../../scss/mixins/*';

.archive{
  display: grid;
  grid-template-columns: 300px 1fr;
  width: 100%;
  padding-top: 30px;
  background-color: #f9f9f9;

  @include responsive(mobile) {
    display: block;
    position: relative;
  }

  .product-listing{
    background-color: #f9f9f9;
  }
}
</style>
